import { StyledActionsRow } from '../DataModelerCommonUI';
import FieldsSubHeader from '../DataModelerFieldsGrid/FieldsSubHeader';
import SearchInput from '../../../../components/Form/SearchInput';
import DataModelerFieldsGrid from '../DataModelerFieldsGrid';
import { useDataModelerContext } from '../../DataModelerContext';
import { useState } from 'react';

const DataModelerFields = () => {
  const { isEditMode, numFields } = useDataModelerContext();

  const [searchQuery, setSearchQuery] = useState('');

  return (
    <>
      <StyledActionsRow $hasSearch={true}>
        <FieldsSubHeader isEditMode={isEditMode} numFields={numFields} />
        <SearchInput
          placeholder={'Search'}
          value={searchQuery}
          onChange={setSearchQuery}
        />
      </StyledActionsRow>
      <DataModelerFieldsGrid searchQuery={searchQuery} />
    </>
  );
};

export default DataModelerFields;
